import { VALIDATE_CHARACTER } from "common/Constants";
import moment from "moment";


export const EligibleList = ["Both", "Male", "Female"];
const AllocationOption = ["Monthly", "Quarterly", "HalfYearly",];
const fixedYear = moment().add(1, "year").year();

const DoYouWant = ["Yes", "No"];
export const getEditLeaveJson = (data) => {
  const EditLeaveForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          // Row 1
          [
            {
              id: 1,
              label: "Leave Name",
              type: "text",
              name: "leaveCategoryName",
              Placeholder: "Leave Name",
              value: data["leaveCategoryName"],
              validationRules: [
                {
                  required: true,
                  message: `Leave Name is required`,
                },
              ],
            },
          ],
          [
            {
              id: 2,
              label: "Number of Days",
              type: "text",
              name: "numberOfLeaves",
              Placeholder: "Number of Days",
              value: data["numberOfLeaves"],
              validationRules: [
                {
                  required: true,
                  message: `Number of Days is required`,
                },
              ],
            },
          ],
          [
            {
              id: 3,
              label: "Eligible",
              type: "radio",
              name: "eligible",
              Placeholder: "Select",
              value: "",
              options: EligibleList,
              validationRules: [
                {
                  required: true,
                  message: `eligible is required`,
                },
              ],
            },
          ],
          [
            {
              id: 11,
              label: "Do you want to include Saturday in this leave?",
              type: "radio",
              name: "isSaturday",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `This field is required`,
                },
              ],
            },
          ],
          [
            {
              id: 4,
              label: "Do you want to include Sundays in this leave?",
              type: "radio",
              name: "weekend",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `This field is required`,
                },
              ],
            },
          ],
          [
            {
              id: 5,
              label: `Do you want to include the "Holidays" you provide in this leave?`,
              type: "radio",
              name: "holiday",
              Placeholder: "Select",
              value: "",
              options: DoYouWant,
              validationRules: [
                {
                  required: true,
                  message: `This field is required`,
                },
              ],
            },
          ],
          // [
          //   {
          //     id: 6,
          //     label: `Does this leave type use an accrual system?`,
          //     type: "radio",
          //     name: "accrual",
          //     Placeholder: "Select",
          //     value: "",
          //     options: DoYouWant,
          //     validationRules: [
          //       {
          //         required: true,
          //         message: `Please select`,
          //       },
          //     ],
          //   },
          // ],
          // ...(data["accrual"] === "Yes"
          //   ? [
          //     [
          //       {
          //         id: 7,
          //         label: `Accrual Frequency`,
          //         type: "radio",
          //         name: "accrualtype",
          //         Placeholder: "Select",
          //         value: "",
          //         options: AllocationOption,
          //         validationRules: [
          //           {
          //             required: true,
          //             message: `Please select`,
          //           },
          //         ],
          //       },
          //     ],
          //   ]
          //   : []),
          // ...(data["rollout"] === "Yes"
          //   ? [
          //     [
          //       {
          //         id: 8,
          //         label: "Expiry Date",
          //         type: "month",
          //         name: "expiry_date",
          //         placeholder: "Select Month",
          //         value: data["expiry_date"] ? moment(data["expiry_date"]) : null,
          //         picker: "month",
          //         format: "MMMM",          // 👈 ONLY month name
          //       }

          //     ],
          //   ]
          //   : []),

        ],
      },
    ],
  };

  return {
    EditLeaveForm,
  };
};
